import apiRequest from './api-request';

const resource = 'order-registrations';

export function getOrderRegistrations() {
    return apiRequest({
        method: 'GET',
        resource
    });
}

export function getOrderRegistration(id: number) {
    return apiRequest({
        method: 'GET',
        resource,
        id
    });
}

export function createOrderRegistrationAccount(
    id: number,
    body?: { companyOrgNumber?: string, phone?: string }
) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/${id}/create-account`,
        body: body || {}
    });
}

export function linkOrderRegistrationAccount(
    id: number,
    body: { tenantId: number, userId?: number }
) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/${id}/link-account`,
        body
    });
}

export function acceptOrderRegistration(id: number) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/${id}/accept`,
        body: {}
    });
}

export function rejectOrderRegistration(id: number, message?: string) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/${id}/reject`,
        body: { message }
    });
}

export function reactivateOrderRegistration(id: number) {
    return apiRequest({
        method: 'POST',
        resource: `${resource}/${id}/reactivate`,
        body: {}
    });
}
